<div class="document-upload">
  <app-upload-document
    #uploadDocument
    [optionalFilesTitle]="'upload.optionalActionPlans'"
    [documentType]="DocumentTypeEnum.ACTION_PLAN"
  ></app-upload-document>
  <div class="options">
    <button
      mat-flat-button
      [disabled]="isSuggestDisabled"
      [class.disabled]="isSuggestDisabled"
      (click)="suggestProducts()"
    >
      {{ 'button.suggestProduct' | translate }}
    </button>
  </div>
</div>
@if (actionPlanExists) {
  <section class="suggestion-results">
    @if (productSuggestionError) {
      <app-rerun-task (rerun)="rerun.emit()"></app-rerun-task>
    } @else {
      @if (suggestedProducts) {
        <section class="products-suggestions-content">
          <h3>{{ 'productSuggestions.basedOn' | translate }} {{ suggestedProducts.reason }}</h3>

          <app-product-table
            [suggestions]="suggestedProducts.suggestions"
            [selectedProducts]="selectedProducts"
            (selectedProductsChange)="selectedProductsChange.emit($event)"
          ></app-product-table>
        </section>
      } @else if (isProductSuggestionInProgress) {
        <section class="products-suggestions-loading">
          <app-waiting [message]="'productSuggestions.loading' | translate"></app-waiting>
        </section>
      }
    }
  </section>
}
